import { EnumItem } from '@core/models/enum-item.model';
import { EstimateTypeEnum } from '@enums/EstimateType';

export const EstimateTypeEnumItems: EnumItem<EstimateTypeEnum>[] = [
  {
    key: EstimateTypeEnum.New,
    titleKey: 'ESTIMATE_TYPE.' + EstimateTypeEnum.New.toUpperCase()
  },
  {
    key: EstimateTypeEnum.Reallocation,
    titleKey: 'ESTIMATE_TYPE.' + EstimateTypeEnum.Reallocation.toUpperCase()
  },
  {
    key: EstimateTypeEnum.AdditionalService,
    titleKey: 'ESTIMATE_TYPE.' + EstimateTypeEnum.AdditionalService.toUpperCase()
  }
];
